var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-list-item-group',{model:{value:(_vm.$selected),callback:function ($$v) {_vm.$selected=$$v},expression:"$selected"}},_vm._l((_vm.items),function(item){return _c('v-list-item',{key:item.guid,attrs:{"value":item}},[_c('v-list-item-content',[_c('v-list-item-title',[_vm._v(_vm._s(item.name))])],1)],1)}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }